import { render } from "./ServicesSection.vue?vue&type=template&id=30b35dfe&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=30b35dfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30b35dfe"

export default script